
export default function Footer() {
  return (
    <footer className="bg-stone-800 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <img 
                src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/d3f566fff327433480db44ef3a925506.png" 
                alt="Meet Hiszpania" 
                className="h-12 w-auto"
              />
              <div className="border-l border-stone-600 h-12"></div>
              <img 
                src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/187f7d51d51430876440814be4b11ce3.png" 
                alt="Hotel Jardín Tecina" 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-stone-300 leading-relaxed">
              Projekt Meet Hiszpania<br />
              we współpracy z<br />
              Hotel Jardín Tecina & Tecina Golf<br />
              La Gomera, Wyspy Kanaryjskie
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-4">Hotel</h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><a href="#hotel" className="hover:text-white transition-colors">O hotelu</a></li>
              <li><a href="#pokoje" className="hover:text-white transition-colors">Pokoje</a></li>
              <li><a href="#relaks" className="hover:text-white transition-colors">Spa & Wellness</a></li>
              <li><a href="#doswiadczenia" className="hover:text-white transition-colors">Doświadczenia</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-4">Usługi</h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><a href="#golf" className="hover:text-white transition-colors">Tecina Golf</a></li>
              <li><a href="#eco-finca" className="hover:text-white transition-colors">Eco Finca</a></li>
              <li><a href="#dojazd" className="hover:text-white transition-colors">Jak dotrzeć</a></li>
              <li><a href="#la-gomera" className="hover:text-white transition-colors">La Gomera</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-4">B2B</h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><a href="#b2b" className="hover:text-white transition-colors">Strefa B2B</a></li>
              <li><a href="#kontakt" className="hover:text-white transition-colors">Kontakt</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Materiały</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Wizyty studyjne</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-stone-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-stone-400">
              © 2025 Meet Hiszpania & Hotel Jardín Tecina. Wszelkie prawa zastrzeżone.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-stone-400 hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}